/**
 * Lichte count-fetcher voor de sidebar-badge op `/kas`. Telt openstaande
 * contante transacties van vóór vandaag — dat is de "achterstand" die
 * gecontroleerd/afgestort moet worden. Wordt 60s gepolld in `AppLayout`.
 *
 * Volledige Kas-data komt uit `kas-store`; deze functie is bewust kaal
 * zodat de sidebar-poll geen volledige transactielijst hoeft te trekken.
 */
import { supabase } from './supabase';

export async function fetchKasOpenVorigeDagen(): Promise<number> {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) return 0;

  // B5 (25-08): mirror-count via het eigen endpoint (was proxy-SOQL).
  const r = await fetch('/api/transacties/kas?countOnly=1', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!r.ok) return 0;
  const data = (await r.json()) as { data?: { openVorigeDagen?: number } };
  return data.data?.openVorigeDagen ?? 0;
}
